import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=51707208&"
import script from "./OrderPayments.vue?vue&type=script&lang=ts&"
export * from "./OrderPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports